// Checks a set of field->value(s) conditions against a state object (e.g. company or restaurant).
// Each key is a field name; its value is either a single allowed value or an array of allowed values.
function matchesFieldRules(fieldRules, state) {
  if (!fieldRules) return true;
  return Object.entries(fieldRules).every(([field, expected]) => {
    const allowed = Array.isArray(expected) ? expected : [expected];
    return allowed.includes(state?.[field]);
  });
}

// A route is available when its base role/permission gate passes, AND (if it defines `rules`)
// at least one rule's company/restaurant field conditions also pass. `rules` only narrows further
// than `roles`/`permissions` - it never grants access on its own, so routes stay safe for every
// consumer of allRoutes() (e.g. RecipientDrawer, PaymentDrawer) even when only some of them use rules.
export function isRouteAvailable(route, { userType, userPermissions, company, restaurant }) {
  const roleGate = route.roles.includes(userType);
  const permissionGate = (route.permissions || []).every((perm) => userPermissions?.[perm]);
  if (!roleGate || !permissionGate) return false;

  const rules = route.rules || [];
  if (!rules.length) return true;

  return rules.some(
    (rule) =>
      matchesFieldRules(rule.companyRules, company) &&
      matchesFieldRules(rule.restaurantRules, restaurant)
  );
}
